import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Microscope } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = '/api';

export default function ScientistOfTheDay() {
  const [scientist, setScientist] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchScientist = async () => {
      try {
        const response = await axios.get(`${API}/science/scientists/daily/scientist-of-the-day`);
        setScientist(response.data.scientist);
      } catch (error) {
        console.error("Scientist fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchScientist();
  }, []);

  if (loading) {
    return (
      <Card className="p-4 bg-gradient-to-br from-blue-500/10 to-blue-600/5 border-blue-500/20 animate-pulse">
        <div className="h-24"></div>
      </Card>
    );
  }

  if (!scientist) return null;

  return (
    <Card className="p-4 bg-gradient-to-br from-blue-500/10 to-blue-600/5 border-blue-500/20 hover:border-blue-500/40 transition-all duration-300">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center flex-shrink-0">
          <Microscope className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-bold text-white truncate">Günün Bilim İnsanı</h3>
          <Badge className="bg-blue-500/80 text-white text-xs mt-1">
            {scientist.field?.split(',')[0] || scientist.field}
          </Badge>
        </div>
      </div>
      
      <h4 className="text-lg font-bold text-blue-200 mb-1 truncate">{scientist.name}</h4>
      <p className="text-white/70 text-xs line-clamp-2 mb-2">
        {scientist.achievement || scientist.bio}
      </p>
      
      {scientist.awards && scientist.awards.length > 0 && (
        <p className="text-blue-100/80 text-xs italic line-clamp-1">
          🏆 {scientist.awards[0]}
        </p>
      )}
    </Card>
  );
}
